export default "__VITE_ASSET__QNZFsnKT__"